/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {FmlxComboBox} from 'fmlx-common-ui';
import {useSelector} from 'react-redux';
import {reviewPeriodBusiness} from '../../stores/business/reviewPeriodBusiness';
import {setSelectedPeriod} from '../../stores/actions/periodAction';
/**
 * @deprecated
 * Avoid using PeriodDropdown component.
 *
 * This component handles internal state (e.g. fetch, dispatch, auto-select),
 * which should be managed in the page level for better control and reusability.
 *
 * Use <FmlxComboBox /> directly in the page and handle data, selection, and events externally.
 */
function PeriodDropdown({callbackChangePeriod, isDisabled}) {
  const dispatch = useDispatch();
  const periods = useSelector((state) => state.periodState.periods);
  const selectedPeriod = useSelector((state) => state.periodState.selected);

  useEffect(() => {
    dispatch(reviewPeriodBusiness.fetchPeriods());
  }, []);

  useEffect(() => {
    if (selectedPeriod) {
      callbackChangePeriod(selectedPeriod.data);
    }
  }, [selectedPeriod]);

  useEffect(() => {
    if (!selectedPeriod && periods.length > 0) {
      const active = periods.find((p) => p.data.isActive);
      if (active) dispatch(setSelectedPeriod(active));
    }
  }, [periods, selectedPeriod]);

  const handleChange = (value) => {
    if (value) {
      dispatch(setSelectedPeriod(value));
    } else {
      dispatch(reviewPeriodBusiness.fetchPeriods());
    }
  };
  return (
    <FmlxComboBox
      id={'periodDropdown'}
      loading={periods.length === 0}
      placeholder="Select Period"
      items={periods}
      selectedItem={selectedPeriod}
      onChange={(e) => handleChange(e)}
      disabled={isDisabled}
    />
  );
}

export default PeriodDropdown;
